import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { toFriendlyDateString } from 'helpers/Formatter';
import { AntdAlert } from '@yuhuinc/ui-library';
import currency from 'currency.js';

const StyledList = styled.ul`
  padding-left: 0;
  margin-bottom: 0;
`;

const LeadPreferencesAlertInfo = ({
  applicantName,
  property,
  unitType,
  moveInDate,
  minBudget,
  maxBudget,
}) => {
  const minBudgetFormatted = currency(minBudget, { fromCents: true }).format();
  const maxBudgetFormatted = currency(maxBudget, { fromCents: true }).format();
  const preferredBudget = `${minBudgetFormatted} - ${maxBudgetFormatted}`;

  const AlertDescription = () => (
    <StyledList>
      <li>
        <strong>Property:</strong> {property}
      </li>
      <li>
        <strong>Unit type:</strong> {unitType}
      </li>
      <li>
        <strong>Move-in date:</strong> {toFriendlyDateString(moveInDate)}
      </li>
      <li>
        <strong>Preferred budget:</strong> {preferredBudget}
      </li>
    </StyledList>
  );

  return (
    <AntdAlert
      type="info"
      message={`${applicantName}’s preferences`}
      description={<AlertDescription />}
      showIcon
      closable={false}
    />
  );
};

LeadPreferencesAlertInfo.propTypes = {
  applicantName: PropTypes.string.isRequired,
  property: PropTypes.string.isRequired,
  unitType: PropTypes.string.isRequired,
  moveInDate: PropTypes.string.isRequired,
  maxBudget: PropTypes.number.isRequired,
  minBudget: PropTypes.number.isRequired,
};

export default LeadPreferencesAlertInfo;
